export const customerRelations = {
  seo: {
    title: "Ügyfélkapcsolat — Bespire AI asszisztens",
    description:
      "Visszahívás, follow-up, értékelés-kezelés, panasz-válaszok. A Bespire AI asszisztens folyamatosan gondoskodik az ügyfeleidről.",
  },
  hero: {
    badge: "Ügyfélkapcsolat",
    title: "Az ügyfeleid ne felejtsenek el téged",
    subtitle:
      "Egy jó vendég megtartása többet ér, mint egy új megszerzése. A Bespire AI folyamatosan figyeli az ügyfeleidet, észreveszi, ki lemorzsolódik, mikor kell köszönetet mondani vagy születésnapot köszönteni — és megírja helyetted.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    customerCard: {
      label: "Ügyfélprofil · illusztráció",
      name: "Nagy Petra",
      initials: "NP",
      subtitle: "Törzsvendég · 5 foglalás",
      lastVisit: "Utolsó foglalás",
      lastVisitValue: "4 hónapja",
      favorite: "Kedvenc szolgáltatás",
      favoriteValue: "Esti jóga (60 perc)",
      spent: "Összköltés",
      spentValue: "62 000 Ft",
      tags: ["Elszunnyadt", "Törzsvendég", "Esti időpont"],
      suggestion: "AI javaslat",
      suggestionText: "3 üzenet-variáns, mind az esti órákra épít. Első jóváhagyásra vár.",
      action: "Visszahívó üzenet küldése",
    },
  },
  journey: {
    title: "Egy ügyfél útja a Bespire-rel",
    subtitle: "Egyetlen ügyfél, öt kontaktpont — a Bespire mindegyiknél tudja, mit kell mondani.",
    stages: [
      {
        icon: "UserPlus",
        time: "1. nap",
        title: "Első foglalás",
        note: "Automatikus visszaigazolás, hangvétel-illesztve",
        message: "Szia Petra! Köszönjük, hogy minket választottál. Csütörtök 18:00-ra vagy foglalva — várunk!",
      },
      {
        icon: "MessageCircle",
        time: "+2 nap",
        title: "Follow-up",
        note: "Köszönet + elégedettség-kérdés",
        message: "Szia Petra! Hogy érezted magad tegnap? Egy szóban is elmondhatod — ez sokat segít.",
      },
      {
        icon: "Star",
        time: "+3 nap",
        title: "Értékelés-kérés",
        note: "Csak akkor, ha a follow-up pozitív volt",
        message: "Örülünk, hogy jól sikerült! Ha van 1 perced, itt egy link — sokat segít másoknak is.",
      },
      {
        icon: "Bell",
        time: "60 nap után",
        title: "Csendes követés",
        note: "Nem üzennek — a naptáradban jelzés",
      },
      {
        icon: "PhoneCall",
        time: "4 hónap után",
        title: "Visszahívó kampány",
        note: "AI észreveszi a lemorzsolódást",
        message: "Szia Petra! Új esti óráink indultak — pont a te időpontjaidban. Első alkalom 30% kedvezmény.",
      },
      {
        icon: "Gift",
        time: "Születésnap",
        title: "Figyelmesség",
        note: "Automatikus, de emberi",
        message: "Boldog születésnapot, Petra! 🎉 Ez a hónap végéig 20% kedvezmény egy tetszőleges órára.",
      },
    ],
  },
  segments: {
    title: "A Bespire szegmentálja helyetted az ügyfeleidet",
    subtitle: "Nem statikus lista — az AI folyamatosan újraszámol a foglalások alapján.",
    items: [
      {
        icon: "Sparkles",
        name: "Új ügyfelek",
        count: "12 fő",
        aiAction: "Onboarding-sorozat: köszönet, tipp, 2. foglalási kedvezmény",
        impact: "+35% visszatérési arány",
      },
      {
        icon: "Heart",
        name: "Aktívak",
        count: "84 fő",
        aiAction: "Havi értékelés-kérés, upsell szolgáltatás-csomagokra",
        impact: "+18% havi bevétel",
      },
      {
        icon: "Moon",
        name: "Elszunnyadtak",
        count: "23 fő",
        aiAction: "Személyre szabott visszahívó ajánlat, kedvencük alapján",
        impact: "~30% visszatér",
      },
      {
        icon: "Crown",
        name: "VIP-k",
        count: "9 fő",
        aiAction: "Születésnap, előfoglalás-elsőbbség, exkluzív óráink",
        impact: "3× átlagos éves érték",
      },
    ],
  },
  templates: {
    title: "Ugyanaz az AI — három csatornán, a te hangvételeddel",
    subtitle: "SMS, email, WhatsApp — de nem sablon: a Bespire a konkrét ügyfél előzményeivel dolgozik.",
    messages: [
      {
        channel: "WhatsApp",
        icon: "MessageCircle",
        sender: "Bella Studio",
        time: "18:04",
        text: "Szia Petra! 🌿 Emlékszel, hogy csütörtökön este 18:00-kor várunk? Ha valami közbejön, egy szó és átteszünk — nem gond.",
      },
      {
        channel: "Email",
        icon: "Mail",
        sender: "kata@regeneracio.hu",
        time: "Ma 09:12",
        subject: "Köszönjük, hogy visszajöttél",
        text: "Kedves Zoltán, örülök, hogy tegnap újra találkoztunk. Küldök egy 45 perces prémium csomag ajánlatot — csak ha érdekel, semmi nyomás. Kata",
      },
      {
        channel: "SMS",
        icon: "Smartphone",
        sender: "+36 20 xxx xxxx",
        time: "10:32",
        text: "Boldog születésnapot, Anna! 🎉 A hónap végéig 20% kedvezmény bármelyik órára. Foglalás: bella.hu",
      },
    ],
  },
  reviews: {
    title: "Értékelések — te jóváhagysz, az AI válaszol",
    subtitle: "Új Google értékelés érkezett? A Bespire kész választ ad — a te hangvételeddel, a konkrét visszajelzésre.",
    items: [
      {
        rating: 5,
        author: "Tóth Andrea",
        time: "2 napja",
        text: "Kata masszázsa életmentő volt egy hosszú hét után. Csend, figyelem, pontosság — pontosan az, amit ígért. Ajánlom mindenkinek!",
        replyTitle: "AI javasolt válasz",
        reply: "Köszönjük, Andrea! 🙏 Örülök, hogy pont azt kaptad, amit ígértem — ez a legjobb visszajelzés, amit kaphatok. Várlak legközelebb is!",
        replyStatus: "Jóváhagyásra vár",
      },
      {
        rating: 3,
        author: "Kovács Balázs",
        time: "5 napja",
        text: "Maga a masszázs jó volt, de 15 percet kellett várnom a bejelentkezésre és nem szóltak. Máshogy nem tudom értékelni.",
        replyTitle: "AI javasolt válasz",
        reply: "Balázs, köszönjük az őszinte visszajelzést. A várakozási időn már dolgozunk, és szeretném pótolni — küldök 15% kedvezményt a következő alkalomra. Kata",
        replyStatus: "Jóváhagyásra vár",
      },
    ],
  },
  guardrail: {
    text: "A kedvezmények és ajánlatok mindig az általad beállított kereten belül működnek — az AI sosem dönt a pénzedről magától.",
  },
  crossLinks: {
    title: "Az ügyfélkapcsolat összeér mindennel",
    subtitle: "A Bespire ugyanabból az adatból tud üzenetet írni, kampányt indítani, és jelezni, ha valamivel foglalkozni kell.",
  },
  cta: {
    title: "Ne veszíts el ügyfelet feledékenységből",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
